module.exports = __webpack_public_path__ + "static/img/home1.34012f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home1.png
// module id = b+F5
// module chunks = 1